<template>
	<div>
		<div>
			<Row style="margin-top: 20px;">
				<Col span=24>
				<Card
					style="margin-bottom: 10px;box-shadow: 2px 2px 4px #a7a7a7;width: 100%;height:70px;white;color: #000000;background-color: white;">
					<Form ref="formInline" :model="formInline" inline style="text-align: left;">
						<FormItem prop="trackName" label="充电站:" :label-width="60">
							<Select placeholder="站点列表" style="width: 120px;" v-model="formInline.StationId">
								<Option :value=0>全部</Option>
								<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">
									{{item.StationName}}</Option>
							</Select>
						</FormItem>
						<!-- <FormItem prop="trackName" label="查询类型:" :label-width="100">
							<Select placeholder="查询类型" style="width: 60px;" v-model="formInline.dateType">
								<Option value="month">按月</Option>
								<Option value="year">按年</Option>
							</Select>
						</FormItem> -->
						<!-- <FormItem label="选择时间" :label-width='70'>
							<DatePicker style="width: 110px;" :type="formInline.dateType" placeholder="Select date"
								v-model="formInline.QueryTime"></DatePicker>
						</FormItem> -->
						<!-- <FormItem label="开始时间" :label-width='70'>
							<DatePicker style="width: 110px;" type="date" format="yyyy-MM-dd" placeholder="开始时间"
								v-model="formInline.TimeBegin"></DatePicker>
						</FormItem> -->
						<!-- <FormItem label="结束时间" :label-width='70'>
							<DatePicker style="width: 110px;" type="date" format="yyyy-MM-dd" placeholder="结束时间"
								v-model="formInline.TimeEnd"></DatePicker>
						</FormItem> -->
						<FormItem label="选择时间" :label-width='70'>
							<DatePicker style="width: 210px;" type="daterange" format="yyyy-MM-dd" placeholder="Select date"
								v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
						</FormItem>
						<FormItem>
							<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
						</FormItem>
						<FormItem>
							<Button type="primary" @click="exportFile" v-if="hasWidgets('export')">导出文件</Button>
						</FormItem>
					</Form>
				</Card>
				</Col>
			</Row>
			<!-- <Card style="margin-bottom: 10px;box-shadow: 2px 2px 4px #a7a7a7;width: 100%;background-color: white;">
				<Row>
					<Col span="5">
					<Tag color="success" type="dot">直流设备数量 {{Summary.DcAmount}} 个</Tag>
					</Col>
					<Col span="5">
					<Tag color="primary" type="dot">交流设备数量 {{Summary.AcAmount}} 个</Tag>
					</Col>
					<Col span="4">
					<Tag color="warning" type="dot">总功率 {{Summary.TotolPower}} KW</Tag>
					</Col>
					<Col span="5">
					<Tag color="default" type="dot">合计充电量 {{Summary.ChargeKwh}} KWh</Tag>
					</Col>
					<Col span="5">
					<Tag color="error" type="dot">合计充电收入 {{Summary.ChargeCost}} 元</Tag>
					</Col>
				</Row>
			</Card> -->
			<Table :row-class-name="rowClassName" style="width: 100%;" :columns="columns1" :data="data1" :height="tableHeight"
				ref="ChargingOrder" :show-summary="true"></Table>
			<MyPage ref="sonPage" :param="pageParam" :url="getStationReportsUrl" @listData='getDeviceData'></MyPage>
			<!-- <Row style="margin-top: 10px;" :gutter="16">
				<Col span=12>
				<Card class="cardStyle">
					<p slot="title">
						<Icon type="ios-film-outline"></Icon>
						充电次数（次）
					</p>
					<div class="echartDiv" id="echart1"></div>
				</Card>
				</Col>
				<Col span=12>
				<Card class="cardStyle">
					<p slot="title">
						<Icon type="ios-film-outline"></Icon>
						充电电量（kwh）
					</p>
					<div class="echartDiv" id="echart2"></div>
				</Card>
				</Col>
			</Row>
			<Row style="margin-top: 10px;" :gutter="16">
				<Col span=12>
				<Card class="cardStyle">
					<p slot="title">
						<Icon type="ios-film-outline"></Icon>
						充电时长（小时）
					</p>
					<div class="echartDiv" id="echart3"></div>
				</Card>
				</Col>
				<Col span=12>
				<Card class="cardStyle">
					<p slot="title">
						<Icon type="ios-film-outline"></Icon>
						充电收入（元）
					</p>
					<div class="echartDiv" id="echart4"></div>
				</Card>
				</Col>
			</Row>
			<Row  style="margin-top: 10px;" :gutter="16">
				<Col span=24>
				<Card class="cardStyle">
					<p slot="title">
						<Icon type="ios-film-outline"></Icon>
						设备{{formInline.dateType=='month'?'月':'年'}}排行
					</p>
					<Table :columns="columns1" :data="data1" ref="table"></Table>
				</Card>
				</Col>
			</Row> -->
		</div>
	</div>
</template>

<script>
	import echart from '../../../js/echarts_hot.js'
	import dateFormat from '../../../../public/js/comm.js'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import Qs from 'qs'
	import webapi from '../../../webapi.js'
	const fixedHeight = 260;
	export default {
		data() {
			return {
				getStationReportsUrl: webapi.base_api_url + '/Statistics/GetStationReports',
				BreadcrumbList: ['统计分析', '>>', '场站报表'],
				formInline: {
					StationId: 0,
					QueryTime: new Date,
					dateType: 'month',
					TimeBegin: dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 31), 'yyyy-MM-dd'),
					TimeEnd: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 31), new Date()],
					Type: 1,
				},
				tableHeight: "650",
				//table标题数据
				columns1: [{
						title: '统计时间',
						key: 'StatisticsTime',
						minWidth: 120.,
						// render: (h, params) => {
						// 	return h('div',
						// 		params.row.StartModeDesc
						// 	);
						// }
					},
					{
						title: '充电电量(度)',
						key: 'ChargeKwh',
						minWidth: 120
					},
					{
						title: '充电电费(元)',
						key: 'ElecCost',
						minWidth: 120
					}, {
						title: '充电服务费(元)',
						key: 'ServiceCost',
						minWidth: 120
					},
					{
						title: '充电总费用(元)',
						key: 'ChargeCost',
						minWidth: 120
					},
					{
						title: '充电时长(小时)',
						key: 'ChargeDuration',
						minWidth: 120,
					},
					{
						title: '充电次数(次)',
						key: 'ChargeNum',
						minWidth: 120
					},
				],
				data1: [],
				//充电设备总计
				Summary: {
					DcAmount: 0,
					AcAmount: 0,
					TotolPower: 0,
					ChargeKwh: 0,
					ChargeCost: 0,
				},
			}
		},
		created() {
			// this.handleSubmit();
			const _this = this;
			// _this.tableHeight = window.innerHeight - fixedHeight;
			this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight);
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					StationId: _this.formInline.StationId,
					StatistisRangeType: _this.formInline.dateType == 'year' ? 3 : 2,
					QueryTime: _this.formInline.QueryTime == '' ? dateFormat.formatDate(new Date(), 'yyyy-MM-dd') : dateFormat
						.formatDate(new Date(_this.formInline.QueryTime), 'yyyy-MM-dd'),
					TimeBegin: _this.formInline.TimeBegin == '' ? '' : dateFormat.formatDate(
						new Date(_this.formInline.TimeBegin), 'yyyy-MM-dd'),
					TimeEnd: _this.formInline.TimeEnd == '' ? '' : dateFormat.formatDate(
						new Date(_this.formInline.TimeEnd), 'yyyy-MM-dd'),
					Type: 1,
				}
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations'
			})
		},
		destroyed() {
			echart.disposeEchart(null);
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.$refs.sonPage.pageSize = 31;
			this.$refs.sonPage.opts = [31, 10000];
			this.$refs.sonPage.show = false;
			this.handleSubmit();
		},
		deactivated() {
			this.$destroy();
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleChange(date, type) {
				console.log("日期改变：", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
				const _this = this;
				//echarts数据
				let url = '';
				//总结数据
				let url2 = '';
				//table数据
				let url3 = '';
				let parms = {
					StationId: _this.formInline.StationId,
					QueryTime: _this.formInline.QueryTime == '' ? dateFormat.formatDate(new Date(), 'yyyy-MM-dd') : dateFormat
						.formatDate(new Date(_this.formInline.QueryTime), 'yyyy-MM-dd'),
					TimeBegin: _this.formInline.TimeBegin == '' ? '' : dateFormat.formatDate(
						new Date(_this.formInline.TimeBegin), 'yyyy-MM-dd'),
					TimeEnd: _this.formInline.TimeEnd == '' ? '' : dateFormat.formatDate(
						new Date(_this.formInline.TimeEnd), 'yyyy-MM-dd'),
					Type: 1,
				};
				_this.axiosMethod(webapi.base_api_url + '/Statistics/GetStationSummary', parms, "Summary")
				// switch (_this.formInline.dateType) {
				// 	case 'date':
				// 		url = webapi.base_api_url + "/Statistics/GetDailyCurves";
				// 		// _this.axiosMethod(url, parms, "echart")
				// 		url2 = '';
				// 		url3 = '';
				// 		break;
				// 	case 'year':
				// 		url = webapi.base_api_url + "/Statistics/GetYearlyCurves";
				// 		// _this.axiosMethod(url, parms, "echart")
				// 		url2 = webapi.base_api_url + '/Statistics/GetYearlyStationSummary';
				// 		url3 = webapi.base_api_url + '/Statistics/GetYearlyEquipmenRank';
				// 		// _this.axiosMethod(url3, parms, "table")
				// 		break;
				// 	case 'month':
				// 		url = webapi.base_api_url + "/Statistics/GetMonthlyCurves";
				// 		// _this.axiosMethod(url, parms, "echart")
				// 		url2 = webapi.base_api_url + '/Statistics/GetMonthlyStationSummary';
				// 		_this.axiosMethod(url2, parms, "Summary")
				// 		url3 = webapi.base_api_url + '/Statistics/GetMonthlyEquipmenRank';
				// 		// _this.axiosMethod(url3, parms, "table")
				// 		break;
				// }
			},
			axiosMethod: function(url, parms, type) {
				const _this = this;
				_this.$axios.post(url, parms, {}).then(res => {
					console.log("axiosMethod")
					console.log(type)
					if (res.data.Code == 0) {
						switch (type) {
							case "echart":
								_this.dealEchart(res)
								break;
							case "Summary":
								_this.dealSummary(res)
								break;
							case "table":
								_this.dealTable(res)
								break;
							default:
								break;
						}
					}
				})
			},
			dealEchart: function(res) {
				const _this = this;
			},
			dealSummary: function(res) {
				console.log("dealSummary")
				console.log(res)
				this.Summary = res.data.Data.Curves
			},
			dealTable: function(res) {
				console.log("dealTable")
				console.log(res)
				this.data1 = res.data.Data
			},
			exportFile: function() {
				this.$refs.ChargingOrder.exportCsv({
					filename: '场站报表',
					data: this.data1.map(k => {
						// k.OrderNo = "\t" + k.OrderNo;
						k.StatisticsTime = '\t' + k.StatisticsTime;
						// k.OrderTime = '\t' + (k.OrderTime || '');
						// k.StartTime = '\t' + (k.StartTime || '');
						// k.EndTime = '\t' + (k.EndTime || '');
						// k.RefundTime = '\t' + (k.RefundTime || '');
						return k;
					})
				})
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - fixedHeight;
			},
			//Page组件回调
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			rowClassName: function(row, index) {
				if (index % 2 == 0) {
					return 'demo-table-info-row';
				} else if (index % 2 == 1) {
					return 'demo-table-error-row';
				}
				return '';
			},
		}
	}
</script>

<style>
	.cardStyle {
		margin-bottom: 20px !important;
		box-shadow: 2px 2px 4px #a7a7a7;
		width: 100% !important;
		color: #000000;
		background-color: #ffffff !important;
		height: 334px;
	}

	.cardStyle p {
		text-align: left;
		color: #000000 !important;
	}

	.cardStyle .echartDiv {
		height: 250px;
	}

	.echartDiv {
		background-color: #ffffff;

	}

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>
